import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  const location = useLocation();
  const currentSlug = location.pathname.replace('/category/', '');

  return (
    <section className="py-6 bg-background-50 border-b border-background-200/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide flex-wrap">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                currentSlug === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
              }`}
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}